/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Word_QuotaInputs */

const en_why_listening_word_quota = /** @type {(inputs: Why_Listening_Word_QuotaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typical word quota`)
};

const es_why_listening_word_quota = /** @type {(inputs: Why_Listening_Word_QuotaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Límite de palabras típico`)
};

/**
* | output |
* | --- |
* | "Typical word quota" |
*
* @param {Why_Listening_Word_QuotaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_word_quota = /** @type {((inputs?: Why_Listening_Word_QuotaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Word_QuotaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_word_quota(inputs)
	return en_why_listening_word_quota(inputs)
});